import React, { useCallback, useEffect, useState } from "react";
import { settings } from "app";
import { Datagrid, DateField, FunctionField, TextField } from "react-admin";
import { Typography } from "@mui/material";
import permissions from "app/permissions";
import SecuredComponent from "server/security/SecuredComponent";
import dataProvider from "server/dataProvider";
import { studentRequests } from "api/studentApi";
import AddMidSemesterGradesDialog from "./AddMidSemesterGradesDialog";
import EditMidSemesterGradeDialog from "./EditMidSemesterGradeDialog";

const MidSemesterGrades = ({ studentEducationId, disciplineId }) => {
  const [grades, setGrades] = useState([]);

  const fetchMidSemesterGrades = useCallback(async () => {
    if (!studentEducationId || !disciplineId) return;
    try {
      const { data } = await dataProvider.customRequest(
        studentRequests.getMidSemesterGrades(studentEducationId, disciplineId),
        null,
        "GET",
      );
      setGrades(data ?? []);
    } catch (err) {
      // The section still renders so grades can be added; nothing for the user to act on
      console.error("Error fetching mid-semester grades", err);
      setGrades([]);
    }
  }, [studentEducationId, disciplineId]);

  useEffect(() => {
    fetchMidSemesterGrades();
  }, [fetchMidSemesterGrades]);

  return (
    <>
      <Typography
        color="primary"
        sx={{ mb: 1 }}
      >
        Междинни семестриални оценки
      </Typography>
      <Datagrid
        data={grades}
        resource="midSemesterGrades"
        bulkActionButtons={false}
        rowClick={false}
        sx={[settings.style.detailsDatagrid, { "& .RaDatagrid-headerCell": { textAlign: "left" } }, { mb: 1 }]}
      >
        <TextField
          source="grade"
          label="Оценка"
          sortable={false}
        />
        <FunctionField
          label="Описание"
          render={rec => rec.comment || "-"}
        />
        <DateField
          source="createdOn"
          label="Дата на въвеждане"
          locales="bg-BG"
          sortable={false}
        />
        <SecuredComponent permission={permissions.canManageMidSemesterGrades}>
          <FunctionField
            render={rec => (
              <EditMidSemesterGradeDialog
                studentEducationId={studentEducationId}
                disciplineId={disciplineId}
                midSemesterGradeId={rec.id}
                fetchMidSemesterGrades={fetchMidSemesterGrades}
              />
            )}
          />
        </SecuredComponent>
      </Datagrid>
      <SecuredComponent permission={permissions.canManageMidSemesterGrades}>
        <AddMidSemesterGradesDialog
          studentEducationId={studentEducationId}
          disciplineId={disciplineId}
          fetchMidSemesterGrades={fetchMidSemesterGrades}
        />
      </SecuredComponent>
    </>
  );
};

export default MidSemesterGrades;
